import React, { useState } from "react";
import { Box, Tabs, Tab, Card, CardContent } from "@mui/material";
import GoogleCredentials from "../Credentials/GoogleCredentials";
import JTLCredentials from "../Credentials/JTLCredentials";
import PlentyCredentials from "../Credentials/PlentyCredentials";
const TabPanel = ({ children, value, index, ...other }) => (
  <div
    role="tabpanel"
    hidden={value !== index}
    id={`credentials-tabpanel-${index}`}
    aria-labelledby={`credentials-tab-${index}`}
    {...other}
  >
    {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
  </div>
);

const CredentialsTab = () => {
  const [credentials, setCredentials] = useState(0);

  const handleCredentialsChange = (event, newValue) => {
    setCredentials(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Card>
        <CardContent>
          <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
            <Tabs
              value={credentials}
              onChange={handleCredentialsChange}
              aria-label="credentials tabs"
            >
              <Tab label="Google Credentials" />
              <Tab label="JTL Credentials" />
              <Tab label="Plenty Credentials" />
            </Tabs>
          </Box>

          {/* Google Credentials Tab */}
          <TabPanel value={credentials} index={0}>
            <GoogleCredentials />
          </TabPanel>

          {/* JTL Credentials Tab */}
          <TabPanel value={credentials} index={1}>
            <JTLCredentials />
          </TabPanel>

          {/* Plenty Credentials Tab */}
          <TabPanel value={credentials} index={2}>
            <PlentyCredentials />
          </TabPanel>
        </CardContent>
      </Card>
    </Box>
  );
};

export default CredentialsTab;
